export default {
  SETTINGS: 'settings',
  STORAGE: 'storage',
  READINESS: 'readiness_gate',
  COLLECTORS: 'metrics_collectors',
  EVENTS: 'events_publisher'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/utils/context/constants.js
// module id = null
// module chunks = 